(function () {
  'use strict';

  /* ─────────────────────────────────────────────────────────────────────────────
     CONSTANTS & ELEMENT REFS
  ───────────────────────────────────────────────────────────────────────────── */
  var itemsLabel    = window.__mt_items_label || 'Items';
  var cartBtn       = document.getElementById('mt-cart-btn');
  var cartBtnMobile = document.getElementById('mt-cart-btn-mobile');
  var cartOverlay   = document.getElementById('cart-overlay');
  var cartDrawer    = document.getElementById('cart-drawer');
  var cartClose     = document.getElementById('cart-close');
  var cartContent   = document.getElementById('cart-content');
  var cartSubtotal  = document.getElementById('cart-subtotal');
  var checkoutBtn   = document.getElementById('cart-checkout');

  /* cached cart state — avoids re-fetching if nothing changed */
  var cartCache     = null;
  var cartDirty     = true;

  /* ─────────────────────────────────────────────────────────────────────────────
     DRAWER OPEN / CLOSE
  ───────────────────────────────────────────────────────────────────────────── */
  function openDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.add('open');
    if (cartOverlay) cartOverlay.classList.add('active');
    document.body.style.overflow = 'hidden';
    if (cartDirty) {
      loadCartContent();
    } else {
      renderCart(cartCache);
    }
  }

  function closeDrawer() {
    if (!cartDrawer) return;
    cartDrawer.classList.remove('open');
    if (cartOverlay) cartOverlay.classList.remove('active');
    document.body.style.overflow = '';
  }

  if (cartBtn)       cartBtn.addEventListener('click',       function (e) { e.preventDefault(); openDrawer(); });
  if (cartBtnMobile) cartBtnMobile.addEventListener('click', function (e) { e.preventDefault(); openDrawer(); });
  if (cartClose)     cartClose.addEventListener('click', closeDrawer);
  if (cartOverlay)   cartOverlay.addEventListener('click', closeDrawer);

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && cartDrawer && cartDrawer.classList.contains('open')) closeDrawer();
  });

  /* ─────────────────────────────────────────────────────────────────────────────
     LOADING / ERROR STATES
  ───────────────────────────────────────────────────────────────────────────── */
  function showLoading() {
    if (!cartContent) return;
    cartContent.innerHTML =
      '<div class="cart-drawer-loading">' +
        '<div class="cart-spinner"></div>' +
        '<p>Loading cart&hellip;</p>' +
      '</div>';
  }

  function showError(msg) {
    if (!cartContent) return;
    cartContent.innerHTML =
      '<div class="cart-drawer-error">' +
        '<p>' + escapeHTML(msg || 'Something went wrong. Please try again.') + '</p>' +
      '</div>';
  }
var searchToggle = document.getElementById('mt-search-toggle');
var mobileSearchBar = document.getElementById('mt-mobile-search-bar');
var mobileSearchInput = document.getElementById('mt-mobile-search-input');

if (searchToggle && mobileSearchBar) {
  searchToggle.addEventListener('click', function (e) {
    e.stopPropagation();
    var isOpen = mobileSearchBar.classList.toggle('open');
    searchToggle.setAttribute('aria-expanded', String(isOpen));
    mobileSearchBar.setAttribute('aria-hidden', String(!isOpen));
    if (isOpen && mobileSearchInput) {
      setTimeout(function () { mobileSearchInput.focus(); }, 50);
    }
  });

  mobileSearchBar.addEventListener('click', function (e) {
    e.stopPropagation();
  });

  document.addEventListener('click', function () {
    if (!mobileSearchBar.classList.contains('open')) return;
    mobileSearchBar.classList.remove('open');
    searchToggle.setAttribute('aria-expanded', 'false');
    mobileSearchBar.setAttribute('aria-hidden', 'true');
  });
}
  /* ─────────────────────────────────────────────────────────────────────────────
     BUILD CART ITEM HTML
  ───────────────────────────────────────────────────────────────────────────── */
  function buildItemHTML(item) {
    var imgSrc = item.featured_image && item.featured_image.url ? item.featured_image.url : null;
    var imageHtml = imgSrc
      ? '<img src="' + imgSrc + '" alt="' + escapeAttr(item.title) + '" loading="lazy" width="85" height="85">'
      : '<div class="cart-item-img-placeholder"></div>';

    var variantInfo = '';
    if (item.variant_title && item.variant_title !== 'Default Title') {
      variantInfo = '<p class="cart-item-variant">' + escapeHTML(item.variant_title) + '</p>';
    }

    var originalPrice = '';
    if (item.original_price && item.original_price > item.price) {
      originalPrice = '<s class="cart-item-compare">&#8377;' + (item.original_price / 100).toFixed(2) + '</s>';
    }

    return (
      '<div class="cart-item" data-key="' + escapeAttr(item.key) + '">' +
        '<div class="cart-item-image">' + imageHtml + '</div>' +
        '<div class="cart-item-info">' +
          '<p class="cart-item-title">' + escapeHTML(item.product_title || item.title) + '</p>' +
          variantInfo +
          '<div class="cart-item-price-row">' +
            '<p class="cart-item-price">&#8377;' + (item.price / 100).toFixed(2) + '</p>' +
            originalPrice +
          '</div>' +
          '<div class="cart-item-controls">' +
            '<div class="cart-item-qty">' +
              '<button type="button" class="qty-btn qty-minus" data-key="' + escapeAttr(item.key) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">&#8722;</button>' +
              '<span class="qty-display">' + item.quantity + '</span>' +
              '<button type="button" class="qty-btn qty-plus"  data-key="' + escapeAttr(item.key) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
            '</div>' +
            '<button type="button" class="cart-item-remove" data-key="' + escapeAttr(item.key) + '" data-qty="0">Remove</button>' +
          '</div>' +
        '</div>' +
      '</div>'
    );
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     LOAD & RENDER CART
  ───────────────────────────────────────────────────────────────────────────── */
  function loadCartContent(cb) {
    showLoading();
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) {
        if (!r.ok) throw new Error('Cart fetch failed: ' + r.status);
        return r.json();
      })
      .then(function (c) {
        cartCache = c;
        cartDirty = false;
        renderCart(c);
        if (typeof cb === 'function') cb(c);
      })
      .catch(function (err) {
        console.error('[MT] Cart load error:', err);
        showError('Could not load cart. Please refresh the page.');
      });
  }

  function renderCart(c) {
    if (!cartContent || !c) return;
    if (c.item_count === 0) {
      cartContent.innerHTML = emptyCartHTML();
      if (cartSubtotal) cartSubtotal.textContent = '\u20B90.00';
    } else {
      var frag = '';
      c.items.forEach(function (item) { frag += buildItemHTML(item); });
      cartContent.innerHTML = '<div class="cart-items-list">' + frag + '</div>';
      if (cartSubtotal) cartSubtotal.textContent = '\u20B9' + ((c.total_price || 0) / 100).toFixed(2);
    }
    setCount(c.item_count || 0);
  }

  function emptyCartHTML() {
    return (
      '<div class="cart-drawer-empty">' +
        '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" aria-hidden="true">' +
          '<circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/>' +
          '<path d="M1 1h4l2.68 13.39a2 2 0 002 1.61h9.72a2 2 0 002-1.61L23 6H6"/>' +
        '</svg>' +
        '<p>Your cart is empty</p>' +
      '</div>'
    );
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     QUANTITY / REMOVE — single delegated listener bound once at init
  ───────────────────────────────────────────────────────────────────────────── */
  if (cartContent) {
    cartContent.addEventListener('click', function (e) {
      var btn = e.target.closest('.qty-btn, .cart-item-remove');
      if (!btn) return;
      e.preventDefault();

      var key = btn.dataset.key;
      var qty = parseInt(btn.dataset.qty, 10);
      if (!key) return;

      btn.disabled = true;
      updateCart(key, qty, function () { btn.disabled = false; });
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     UPDATE CART ITEM
  ───────────────────────────────────────────────────────────────────────────── */
  function updateCart(key, qty, cb) {
    fetch('/cart/change.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
    .then(function (r) {
      if (!r.ok) throw new Error('Cart update failed: ' + r.status);
      return r.json();
    })
    .then(function (c) {
      cartCache = c;
      cartDirty = false;
      renderCart(c);
      if (typeof cb === 'function') cb();
    })
    .catch(function (err) {
      console.error('[MT] Cart update error:', err);
      showError('Could not update cart. Please try again.');
      if (typeof cb === 'function') cb();
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     BADGE COUNT
  ───────────────────────────────────────────────────────────────────────────── */
  function setCount(n) {
    var el   = document.getElementById('mt-cart-count');
    var btn  = document.getElementById('mt-cart-btn');
    var btnM = document.getElementById('mt-cart-btn-mobile');
    if (el)   el.textContent    = n + ' ' + itemsLabel;
    if (btn)  btn.dataset.count = n;
    if (btnM) btnM.dataset.count = n;
  }

  function syncCount() {
    /* mark dirty so next drawer open re-fetches */
    cartDirty = true;
    fetch('/cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) { setCount(c.item_count || 0); })
      .catch(function (err) { console.error('[MT] Count sync error:', err); });
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     INTERCEPT FETCH-BASED CART MUTATIONS (third-party / non-hijacked)
  ───────────────────────────────────────────────────────────────────────────── */
  var _origFetch = window.fetch;
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url ? input.url : '');
    var pr  = _origFetch.call(window, input, init);
    if (/\/cart\/(add|change|update|clear)/.test(url)) {
      pr.then(function () { syncCount(); }).catch(function () {});
    }
    return pr;
  };

  /* ─────────────────────────────────────────────────────────────────────────────
     INTERCEPT XHR-BASED CART MUTATIONS
  ───────────────────────────────────────────────────────────────────────────── */
  var _origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (m, u) {
    this._mtUrl = u;
    return _origOpen.apply(this, arguments);
  };
  var _origSend = XMLHttpRequest.prototype.send;
  XMLHttpRequest.prototype.send = function () {
    if (this._mtUrl && /\/cart\/(add|change|update|clear)/.test(this._mtUrl)) {
      this.addEventListener('load', syncCount);
    }
    return _origSend.apply(this, arguments);
  };

  /* ─────────────────────────────────────────────────────────────────────────────
     THEME CART EVENTS
  ───────────────────────────────────────────────────────────────────────────── */
  ['cart:updated', 'cart:refresh', 'ajaxCart:itemAdded', 'theme:cart:update'].forEach(function (evt) {
    document.addEventListener(evt, syncCount);
  });

  /* ─────────────────────────────────────────────────────────────────────────────
     HIJACK PRODUCT FORM SUBMISSIONS
  ───────────────────────────────────────────────────────────────────────────── */
  function hijackForm(form) {
    if (form._mt) return;
    form._mt = true;

    form.addEventListener('submit', function (e) {
      var idField = form.querySelector('[name="id"]');
      if (!idField || !idField.value) return;
      e.preventDefault();
      e.stopImmediatePropagation();

      var variantId = idField.value;
      var submitBtn = form.querySelector('[type="submit"], button.fc-card__atc');
      var orig      = submitBtn ? submitBtn.innerHTML : '';

      if (submitBtn) {
        submitBtn.disabled  = true;
        submitBtn.innerHTML = 'Adding&hellip;';
      }

      _origFetch('/cart/add.js', {
        method: 'POST',
        credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Add to cart failed: ' + r.status);
        return r.json();
      })
      .then(function (cartItem) {

        /* 1. Mark dirty & update badge immediately from response */
        cartDirty = true;
        var newCount = (cartCache ? cartCache.item_count : 0) + 1;
        setCount(newCount);

        /* 2. Fire Meta Pixel AddToCart */
        if (typeof fbq === 'function') {
          var card    = form.closest('.fc-card');
          var titleEl = card ? card.querySelector('.fc-card__title') : null;
          fbq('track', 'AddToCart', {
            content_ids:  [variantId],
            content_type: 'product',
            content_name: titleEl ? titleEl.textContent.trim() : (cartItem.product_title || cartItem.title || ''),
            value:        cartItem.price / 100,
            currency:     (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) ? window.Shopify.currency.active : 'INR',
            num_items:    1
          });
        }

        /* 3. Button success feedback */
        if (submitBtn) {
          submitBtn.disabled           = false;
          submitBtn.innerHTML          = '\u2713 Added!';
          submitBtn.style.background   = '#1d9e75';
          submitBtn.style.color        = '#e1f5ee';
          submitBtn.style.borderColor  = '#1d9e75';
          setTimeout(function () {
            submitBtn.innerHTML         = orig;
            submitBtn.style.background  = '';
            submitBtn.style.color       = '';
            submitBtn.style.borderColor = '';
            submitBtn.disabled          = false;
          }, 2000);
        }

        /* 4. Open drawer — loadCartContent fires because cartDirty = true */
        openDrawer();
      })
      .catch(function (err) {
        console.warn('[MT] Add-to-cart error:', err);
        if (submitBtn) { submitBtn.disabled = false; submitBtn.innerHTML = orig; }
        form._mt = false;
        form.submit();
      });
    }, true);
  }

  function hijackAll() {
    document.querySelectorAll('form[action*="/cart/add"]').forEach(hijackForm);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', hijackAll);
  } else {
    hijackAll();
  }

  document.addEventListener('submit', function (e) {
    if (e.target && e.target.action && e.target.action.indexOf('/cart/add') > -1) {
      hijackForm(e.target);
    }
  }, true);

  new MutationObserver(function (mutations) {
    mutations.forEach(function (m) {
      m.addedNodes.forEach(function (node) {
        if (node.nodeType !== 1) return;
        if (node.matches && node.matches('form[action*="/cart/add"]')) hijackForm(node);
        if (node.querySelectorAll) node.querySelectorAll('form[action*="/cart/add"]').forEach(hijackForm);
      });
    });
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ─────────────────────────────────────────────────────────────────────────────
     CHECKOUT BUTTON — goes to /cart so Shiprocket gateway loads
  ───────────────────────────────────────────────────────────────────────────── */
  if (checkoutBtn) {
    checkoutBtn.addEventListener('click', function () {
      window.location.href = '/cart';
    });
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     NAV — hover dropdowns
  ───────────────────────────────────────────────────────────────────────────── */
  var nav = document.querySelector('.mt-nav-list');
  if (nav) {
    nav.addEventListener('mouseenter', function (e) {
      var dd = e.target.closest('details');
      if (dd) dd.setAttribute('open', '');
    }, true);
    nav.addEventListener('mouseleave', function (e) {
      var dd = e.target.closest('details');
      if (dd && !dd.contains(e.relatedTarget)) dd.removeAttribute('open');
    }, true);
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     STICKY HEADER
  ───────────────────────────────────────────────────────────────────────────── */
  class StickyHeader extends HTMLElement {
    connectedCallback() {
      this.header  = document.querySelector('.section-header');
      this.always  = ['always', 'reduce-logo-size'].includes(this.dataset.stickyType);
      this.cur     = 0;
      this.bounds  = {};
      this.ticking = false;

      if (this.always) this.header.classList.add('shopify-section-header-sticky');
      this._setH();

      if (window.ResizeObserver) {
        new ResizeObserver(() => this._setH()).observe(this.header);
      }
      window.matchMedia('(max-width:990px)').addEventListener('change', () => this._setH());

      this._scroll = () => {
        if (!this.ticking) {
          requestAnimationFrame(() => { this._onScroll(); this.ticking = false; });
          this.ticking = true;
        }
      };
      window.addEventListener('scroll', this._scroll, { passive: true });

      new IntersectionObserver((entries, obs) => {
        this.bounds = entries[0].intersectionRect;
        obs.disconnect();
      }).observe(this.header);
    }

    _setH() {
      document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + 'px');
    }

    disconnectedCallback() {
      window.removeEventListener('scroll', this._scroll);
    }

    _onScroll() {
      const t  = window.scrollY;
      const b  = this.bounds.bottom || 0;
      const bt = this.bounds.top    || 0;

      if (t > this.cur && t > b) {
        this.header.classList.add('scrolled-past-header');
        if (!this.always) {
          this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
        }
      } else if (t < this.cur && t > b) {
        this.header.classList.add('scrolled-past-header', 'shopify-section-header-sticky', 'animate');
        if (!this.always) this.header.classList.remove('shopify-section-header-hidden');
      } else if (t <= bt) {
        this.header.classList.remove(
          'scrolled-past-header', 'shopify-section-header-hidden',
          'shopify-section-header-sticky', 'animate'
        );
      }
      this.cur = t;
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  /* ─────────────────────────────────────────────────────────────────────────────
     UTILITIES
  ───────────────────────────────────────────────────────────────────────────── */
  function escapeHTML(str) {
    return String(str)
      .replace(/&/g, '&amp;').replace(/</g, '&lt;')
      .replace(/>/g, '&gt;').replace(/"/g, '&quot;');
  }
  function escapeAttr(str) {
    return String(str).replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

}());